import get from 'lodash/get';
import map from 'lodash/map';
import { convertNumberToString } from '../../../utils/formatNumber';
import { defaultConfigToApply } from '../../../utils/randomPhoto';
import { shareInfo } from '../../../utils/shareInfo';

const s3 = process.env.FTP_IMAGENS;

const formattGallery = (gallery: any) => {
  const formattedGallery = map(gallery, (item, idx) => {
    return {
      id: idx,
      photo: `${s3}${item}`,
    };
  });
  return formattedGallery;
};

const dataSheetFormat = (data: any) => {
  const {
    model,
    description,
    transmission,
    price,
    mileage,
    ports,
    fuelType,
    color,
    axles,
    bodyStyle,
    matchType,
    coolingType,
    marches,
    motor,
    seatsAmount,
    busType,
    length,
    loadCapacity,
    capacityOfPerson,
    model: { type },
  } = data;
  const { modelYear, fabricationYear, brandName, version, name } = model;
  return {
    about: description || '--',
    color: color || '--',
    fuel: fuelType || '--',
    model: `${brandName || '--'} ${name || '--'} ${version || ''}`,
    motor: motor || '--',
    numberDoors: ports || '--',
    odometer: convertNumberToString(mileage) || '--',
    price: price || '--',
    transmission: transmission || '--',
    typeVehicle: bodyStyle || '--',
    vehicleSituation: '',
    axles: axles || '',
    year: modelYear || '--',
    yearFabrication: fabricationYear || '--',
    matchType: matchType || '--',
    coolingType: coolingType || '--',
    marches: marches || '--',
    seatsAmount: seatsAmount || '--',
    busType: busType || '--',
    type: type || 1,
    brand: brandName,
    length: length || '--',
    loadCapacity: loadCapacity || '--',
    capacityOfPerson: capacityOfPerson || '--',
  };
};

const userFormatter = (dataUser: any) => {
  const { companyName, name, whatsapp, phone, fantasyName, type } = dataUser;
  const formattedUser = {
    companyName: companyName || '--',
    name: name || '--',
    whatsapp: whatsapp || '--',
    phone: phone || '--',
    fantasyName: fantasyName || '--',
    type: type || '--',
  };
  return formattedUser;
};

const verifyTypePerson = (user: any) => {
  const { type, fantasyName, name } = user;
  // 1: fisica, 2: juridica
  switch (type) {
    case '1':
      return name || '--';
    case '2':
      return fantasyName || '--';
  }
};

const addresFormatter = (dataAddress: any) => {
  const { user, city, state } = dataAddress;
  const { address, addressNumber, addressDistrict, cep, phone, type, whatsapp } = user;
  const { bgColor } = defaultConfigToApply;
  const formatterAddress = {
    s3,
    urlImg: get(user, 'urlCompanyLogo', null),
    nameStore: verifyTypePerson(user),
    bgColor,
    phone: phone || '--',
    whatsapp: whatsapp || '--',
    address: {
      city: `${city || '--'} - ${state || '--'}`,
      cepAddress: cep || '--',
      district: addressDistrict || '--',
      street: `${address || '--'}, ${addressNumber || '--'} `,
      type,
    },
    id: user.id || user.autoscarId,
  };

  return formatterAddress;
};

const isToCall = (dataUser: any) => {
  const { whatsapp } = dataUser;
  return !whatsapp;
};

export const formatterAdvertisement = (data: any) => {
  const { user } = data;
  const newData = {
    gallery: { photos: formattGallery(get(data, 'photoUrl', {})) },
    dataSheet: dataSheetFormat(data),
    user: userFormatter(user),
    address: addresFormatter(data),
    optionals: get(data, 'optionals', {}),
    hasToCall: isToCall(user),
    shareData: shareInfo(),
  };

  return newData;
};

const productDataSheetFormatter = (unformattedData: any) => {
  const { type, category, productType, productState, warranty, productDescription } =
    unformattedData;
  return {
    type,
    category,
    productType,
    productState,
    warranty,
    productDescription,
  };
};

export const formatterProductAdvertisement = (data: any) => {
  const { name, price, limitCount, autoscarId } = data;
  const newData = {
    productId: autoscarId,
    name,
    price,
    limitCount,
    gallery: { photos: formattGallery(get(data, 'photoUrl', {})) },
    dataSheet: productDataSheetFormatter(data),
    address: addresFormatter(data),
    shareData: shareInfo(),
  };
  return newData;
};
